<app-header></app-header>
<header class="slidermain menu-page text-white login-page">
    <img src="assets/img/productb1.jpg" alt="news" class="w-100">
  <div class="container-fluid">
     <div class="mask-content-v-center text-left log-card">

        <div class="col-md-4 mx-auto">
         
        <div class="login-box">
            <div class="card-body login-card">
                <h5 class="card-title">{{ 'login.v_otp' | translate }}</h5>
                    <div class="form-signin">
                    <form (ngSubmit)="otpFormSubmit(f)" #f="ngForm"> 
                    <div class="form-group">
                        <label for="">{{ 'login.ch_email' | translate }}</label>
                        <input type="text" class="form-control" name="otp" 
                        required ngModel minlength="6" maxlength="6" #otp="ngModel"> 
                    </div>
                    <!-- <span class="errcls" *ngIf="!otp.valid && otp.touched">Please enter a valid OTP.</span> -->
                    <span class="errcls" *ngIf="errmsg !='' && showLang == 'en' ">{{errmsg}}</span>
                    <span class="errcls" *ngIf="errmsg !='' && showLang == 'ar' ">{{errmsg_ar}}</span>

                    <span  class="text-success" *ngIf="sucsmsg !='' && showLang == 'en' ">{{sucsmsg}}</span>
                    <span  class="text-success" *ngIf="sucsmsg !='' && showLang == 'ar' ">{{sucsmsg_ar}}</span>

                    <p><a href="javascript:void(0)" (click)="resendOTP()">{{ 'login.re_otp' | translate }}</a></p>
                    <button type="submit" class="btn btn-lg btn-primary orderonline"><i class="fas fa-sign-in-alt"></i> {{ 'login.v_now' | translate }} 
                        <span *ngIf="isLoading">
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </span>
                    </button>
                    </form>
                </div> 
            </div>
        </div>
            
 </div>
</div>
</div>
</header>
